<template>
  <div v-if="shouldShowGift" class="first-day-gift-wrap">
    <div class="first-day-gift">
      <div class="gift-left">
        <div ref="giftLottie" class="gift-icon"></div>
        <div class="gift-title">
          {{ `首${conpack_type === 2 ? "日" : "周"}礼` }}
        </div>
        <div class="gift-countdown">
          <span
            v-for="(part, index) in countdownDisplay.parts"
            :key="`countdown-part-${index}`"
            class="gift-countdown-group"
          >
            <span class="gift-time-item">
              <span class="gift-time-item-number">
                {{ part }}
              </span>
            </span>
            <span
              v-if="
                countdownDisplay.separators[index] &&
                countdownDisplay.timeType === 'hour'
              "
              :class="[
                'gift-time-separator',
                countdownDisplay.timeType === 'hour' && 'hour-separator',
              ]"
            >
              <img
                class="hour-separator-icon"
                src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/Ellipse%203.svg"
                alt=""
              />
              <img
                class="hour-separator-icon"
                src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/Ellipse%203.svg"
                alt=""
              />
            </span>
            <span
              v-if="
                countdownDisplay.separators[index] &&
                countdownDisplay.timeType === 'day'
              "
              :class="[
                'gift-time-separator',
                countdownDisplay.timeType === 'hour' && 'hour-separator',
              ]"
            >
              {{ countdownDisplay.separators[index] }}
            </span>
          </span>
        </div>
      </div>
      <div class="flex-center-start" @click="openGiftPopup">
        <div class="gift-action">查看赠品</div>
        <img
          class="gift-arrow"
          src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/rightGiftView.png"
          alt=""
        />
      </div>
    </div>
    <GiftModal
      ref="openGiftPopup"
      :giftInfo="modalGiftInfo"
      :conPackType="conpack_type"
    />
  </div>
</template>

<script>
import GiftModal from "./GiftModal";
import lottie from "lottie-web";
import giftLottieData from "../../../assets/img/lihe_lottie/lihe_lottie.json";
import giftLottieImage from "../../../assets/img/lihe_lottie/demo/images/lihe.png";

export default {
  props: {
    packageInfo: {
      type: Object,
      default: () => ({}),
    },
    listType: {
      type: String,
      default: "",
    },
    cardType: {
      type: String,
      default: "",
    },
    status: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    GiftModal,
  },
  data() {
    return {
      giftCountdown: 0,
      giftTimer: null,
      giftAnimation: null,
    };
  },
  computed: {
    giftInfo() {
      return (this.$$(this.packageInfo, "gift_list", []) || []).map((item) => ({
        gift_name: item.name,
        gift_num: item.quantity || 1,
        gift_product_type: item.type,
        gift_product_ids: item.id,
        pic_url: Array.isArray(item.pic_url)
          ? item.pic_url[0] || ""
          : item.pic_url,
      }));
    },
    conpackType2List() {
      return (this.packageInfo?.conpack_list || []).filter(
        (item) => Number(item?.conpack_type) === 2
      );
    },
    conpackType3List() {
      return (this.packageInfo?.conpack_list || []).filter(
        (item) => Number(item?.conpack_type) === 3
      );
    },
    conpack_type() {
      if (this.conpackType2List.length > 0) return 2;
      if (this.conpackType3List.length > 0) return 3;
      return 1;
    },
    shouldShowGift() {
      return (
        this.conpack_type !== 1 &&
        this.listType === "common" &&
        this.cardType === "raw" &&
        ![3].includes(+this.status?.id)
      );
    },
    modalGiftInfo() {
      if (this.conpack_type === 2) {
        return this.formatGiftInfo(
          this.getSameEarliestEndTimeList(this.conpackType2List)
        );
      }
      if (this.conpack_type === 3) {
        return this.formatGiftInfo(
          this.getSameEarliestEndTimeList(this.conpackType3List)
        );
      }
      return this.giftInfo;
    },
    countdownDisplay() {
      // const showDayMode =
      //   this.conpack_type === 3 ||
      //   (this.conpack_type === 2 && Math.floor(this.giftCountdown / 3600) > 24);
      const showDayMode = Math.floor(this.giftCountdown / 3600) > 24;

      if (showDayMode) {
        const day = Math.floor(this.giftCountdown / 86400);
        const hour = Math.floor((this.giftCountdown % 86400) / 3600);
        const minute = Math.floor((this.giftCountdown % 3600) / 60);

        return {
          parts: [day, hour, minute].map((item) =>
            String(item).padStart(2, "0")
          ),
          separators: ["天", "时", "分"],
          timeType: "day",
        };
      }

      const hour = Math.floor(this.giftCountdown / 3600);
      const minute = Math.floor((this.giftCountdown % 3600) / 60);
      const second = this.giftCountdown % 60;

      return {
        parts: [hour, minute, second].map((item) =>
          String(item).padStart(2, "0")
        ),
        separators: [":", ":", ""],
        timeType: "hour",
      };
    },
  },
  methods: {
    createGiftAnimationData() {
      const animationData = JSON.parse(JSON.stringify(giftLottieData));
      animationData.assets = (animationData.assets || []).map((asset) => ({
        ...asset,
        ...(asset.id === "image_0" ? { u: "", p: giftLottieImage } : {}),
      }));
      return animationData;
    },
    initGiftAnimation() {
      const container = this.$refs.giftLottie;
      if (!container) return;

      this.destroyGiftAnimation();
      this.giftAnimation = lottie.loadAnimation({
        container,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: this.createGiftAnimationData(),
        rendererSettings: {
          preserveAspectRatio: "xMidYMid meet",
        },
      });
    },
    destroyGiftAnimation() {
      if (this.giftAnimation) {
        this.giftAnimation.destroy();
        this.giftAnimation = null;
      }
    },
    syncGiftAnimation() {
      this.$nextTick(() => {
        if (this.$refs.giftLottie) {
          this.initGiftAnimation();
          return;
        }
        this.destroyGiftAnimation();
      });
    },
    openGiftPopup() {
      this.$refs.openGiftPopup &&
        this.$refs.openGiftPopup.init(this.modalGiftInfo);
    },
    formatGiftInfo(giftList = []) {
      return giftList.map((item) => ({
        gift_name: item.name || item.gift_name,
        gift_num: item.quantity || item.gift_num || 1,
        gift_product_type: item.type || item.gift_product_type,
        gift_product_ids: item.id || item.gift_product_ids,
        pic_url: Array.isArray(item.pic_url)
          ? item.pic_url[0] || ""
          : item.pic_url,
      }));
    },
    getValidTimestamp(time) {
      if (!time) return 0;
      const numericTime = Number(time);
      if (!Number.isNaN(numericTime) && numericTime > 0) {
        return numericTime < 1000000000000 ? numericTime * 1000 : numericTime;
      }
      const parsedTime = new Date(time).getTime();
      return Number.isNaN(parsedTime) ? 0 : parsedTime;
    },
    getConpackEndTimestamp(conpackList = []) {
      const validTimes = conpackList
        .map((item) => this.getValidTimestamp(item?.conpack_end_time))
        .filter((item) => item > 0);
      if (!validTimes.length) return 0;
      return Math.min(...validTimes);
    },
    getSameEarliestEndTimeList(conpackList = []) {
      const earliestTimestamp = this.getConpackEndTimestamp(conpackList);
      if (!earliestTimestamp) return conpackList;
      return conpackList.filter(
        (item) =>
          this.getValidTimestamp(item?.conpack_end_time) === earliestTimestamp
      );
    },
    getGiftEndTimestamp() {
      if (this.conpack_type === 2 || this.conpack_type === 3) {
        const endTimestamp = this.getConpackEndTimestamp(
          this.conpack_type === 2
            ? this.conpackType2List
            : this.conpackType3List
        );
        if (endTimestamp > 0) return endTimestamp;
      }
      const now = new Date();
      const targetTime = new Date(now);
      targetTime.setHours(20, 0, 0, 0);
      if (targetTime.getTime() <= now.getTime()) {
        targetTime.setDate(targetTime.getDate() + 1);
      }
      return targetTime.getTime();
    },
    updateGiftCountdown() {
      const nowTimestamp = Date.now();
      const endTimestamp = this.getGiftEndTimestamp();
      this.giftCountdown = Math.max(
        0,
        Math.floor((endTimestamp - nowTimestamp) / 1000)
      );
    },
    startGiftCountdown() {
      this.clearGiftCountdown();
      if (this.conpack_type === 1) return;
      this.updateGiftCountdown();
      this.giftTimer = setInterval(() => {
        this.updateGiftCountdown();
      }, 1000);
    },
    clearGiftCountdown() {
      if (this.giftTimer) {
        clearInterval(this.giftTimer);
        this.giftTimer = null;
      }
    },
  },
  watch: {
    packageInfo: {
      immediate: true,
      handler() {
        this.startGiftCountdown();
      },
      deep: true,
    },
    shouldShowGift: {
      immediate: true,
      handler() {
        this.startGiftCountdown();
        this.syncGiftAnimation();
      },
    },
  },
  mounted() {
    this.startGiftCountdown();
    this.syncGiftAnimation();
  },
  beforeDestroy() {
    this.clearGiftCountdown();
    this.destroyGiftAnimation();
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/layout.less";

.first-day-gift-wrap {
  margin-top: 16px;
  width: 288px;
  margin-left: auto;
}

.first-day-gift {
  .flex-between-center;
  height: 24px;
  padding-left: 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ffefef 0%, #fffafa 100%);
}

.gift-left {
  .flex-center-start;
  min-width: 0;
  margin-left: -15px;
}

.gift-icon {
  position: relative;
  width: 28px;
  height: 28px;
  right: 5px;
  // flex-shrink: 0;
}

.gift-icon /deep/ svg {
  display: block;
  width: 100%;
  height: 100%;
}

.gift-title {
  flex-shrink: 0;
  margin-top: 2px;
  margin-right: 4px;
  color: #f93834;
  font-family: "FZZhengHeiS-EB-GB";
  font-size: 15px;
  font-weight: 400;
  // line-height: 17px;
  // font-style: Regular;
  font-style: normal;
  font-weight: 400;
  // line-height: normal;
  transform: skew(-8deg);
}

.gift-countdown {
  .flex-center-start;
  flex-shrink: 0;
}

.gift-countdown-group {
  display: inline-flex;
  align-items: center;
}

.gift-time-item {
  display: inline-block;
  box-sizing: border-box;
  width: 18px;
  line-height: 16px;
  border-radius: 4px;
  background: #f93834;
  color: #ffffff;
  text-align: center;
  font-family: DIN-Bold-700;
  font-size: 13px;
}

.gift-time-item-number {
  font-family: DIN-Bold-700;
  font-weight: 700;
  font-style: Bold;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
}

.gift-time-separator {
  margin: 0 2px;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  text-align: center;
  color: #f93834;
  font-family: D-DIN-PRO;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

.hour-separator {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 2px;
  line-height: 10px;
  margin: 0 2px;
}

.hour-separator-icon {
  display: block;
  width: 2px;
  height: 2px;
  flex-shrink: 0;
}

.hour-separator-icon + .hour-separator-icon {
  margin-top: 1px;
}

.gift-action {
  flex-shrink: 0;
  margin-left: 12px;
  color: #f93834;
  font-family: "PingFang SC";
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
}

.gift-arrow {
  width: 12px;
  height: 12px;
  margin-left: 2px;
  margin-right: 4px;
  color: #f93834;
}
</style>
